module.exports = __webpack_public_path__ + "assets/facebook-379f87.svg";